module.exports = __webpack_public_path__ + "img/d08e739.png";